import { render, staticRenderFns } from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=template&id=b5034c70&scoped=true"
import script from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=script&lang=js"
export * from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioComercialSalesOrderDetalhadoView.vue?vue&type=style&index=0&id=b5034c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5034c70",
  null
  
)

export default component.exports